(() => {
  if (customElements.get('product-faq-accordion')) return;
  customElements.define('product-faq-accordion', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.states = new Map();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('details').forEach(item => {
        const summary = item.querySelector('summary');
        this.states.set(item, { expanded: item.open, animation: null, reveal: null });
        summary.addEventListener('click', event => {
          event.preventDefault();
          this.toggle(item, !this.states.get(item).expanded);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('details');
        if (this.states.has(item)) this.toggle(item, true);
      }, options);
      window.addEventListener('resize', () => {
        this.states.forEach((state, item) => { if (state.animation) this.finish(item); });
      }, options);
    }

    toggle(item, expanded) {
      const state = this.states.get(item);
      const startHeight = item.getBoundingClientRect().height;
      state.animation?.cancel();
      state.expanded = expanded;
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.coin-product-faq__answer');
      const previousOpacity = getComputedStyle(answer).opacity;
      const previousTransform = getComputedStyle(answer).transform;
      const wasAnimating = Boolean(state.reveal);
      state.reveal?.cancel();
      summary.setAttribute('aria-expanded', String(expanded));
      answer.inert = !expanded;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.finish(item);
        return;
      }
      item.open = true;
      const border = parseFloat(getComputedStyle(item).borderTopWidth) + parseFloat(getComputedStyle(item).borderBottomWidth);
      const endHeight = expanded ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      item.style.overflow = 'hidden';
      state.animation = item.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], {
        duration: expanded ? 460 : 340, easing: 'cubic-bezier(.22, 1, .36, 1)'
      });
      state.reveal = answer.animate([
        { opacity: wasAnimating ? previousOpacity : expanded ? 0 : 1, transform: wasAnimating ? previousTransform : expanded ? 'translateY(-8px)' : 'translateY(0)' },
        { opacity: expanded ? 1 : 0, transform: expanded ? 'translateY(0)' : 'translateY(-5px)' }
      ], { duration: expanded ? 380 : 180, delay: expanded && !wasAnimating ? 60 : 0, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' });
      state.animation.onfinish = () => this.finish(item);
    }

    finish(item) {
      const state = this.states.get(item);
      item.open = state.expanded;
      state.animation?.cancel();
      state.animation = null;
      state.reveal?.cancel();
      state.reveal = null;
      item.style.removeProperty('overflow');
      item.querySelector('summary').setAttribute('aria-expanded', String(state.expanded));
      item.querySelector('.coin-product-faq__answer').inert = !state.expanded;
    }

    disconnectedCallback() {
      this.controller.abort();
      this.states.forEach((state, item) => this.finish(item));
    }
  });
})();
